import React from 'react';
import { Link } from 'react-router-dom';
import ReferrerImage from '../../images/slickslide-6.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Meta from '../../common/Meta';
import './referrals.scss';
import './referrals.darkmode.scss';
import { Container } from '@mui/material';

const Referrals = () => <Container maxWidth="md" className='referrals'>
    <div className="container">
        <Meta title='Referrals' />
        <div className="section page-title">
            <div className="page-title-container"><h1>Become a Referrer</h1></div>
        </div>
        <div className="referrer-box-container">
            <h3>Become a Referrer</h3>
            <p>You earn 5% (LIFETIME) of all Subscription income, tips, and Pay per View Message revenue made by any user that joins Privaposts.com via your referral URL. It does not include income your referred user earns through their own referrals.</p>
            <p>Your unique referral code can be found on your "My Settings" page or your "Become a creator" page.</p>
            <p><Link to="/register" className="btn theme-btn theme-btn-2">Register</Link></p>
            <LazyLoadImage src={ReferrerImage} />
        </div>
    </div>
</Container>;

export default Referrals;
